// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import vuetify from './plugins/vuetify'
import i18n from './i18n'

// Importar CSS dos ícones MDI
import '@mdi/font/css/materialdesignicons.css'

// Importar estilos SCSS globais
import '@/assets/styles/main.scss'

createApp(App)
  .use(createPinia())
  .use(router)
  .use(vuetify)
  .use(i18n)
  .mount('#app')
